// Checks if feature flag is enabled for users on test role
function enabledForTest(flag, user) {
  return user && user.role === "test_role" && flag.status === "test_only";
}

// Checks if flag is assigned to a certain cohort
function activeForCohort(flag, user) {
  return user && flag.cohort === user.cohort;
}

// Checks if flag is assigned to a certain cohort
// and the flag is eneabled for all users or enabled
// for test users
function enabledForCohort(flag, user) {
  return (
    (flag.status === "active" && activeForCohort(flag, user)) ||
    activeForCohortTestOnly(flag, user)
  );
}

// Checks if a flag is enabled for only test users
// within a cohort.
function activeForCohortTestOnly(flag, user) {
  return activeForCohort(flag, user) && enabledForTest(flag, user);
}

// Checks if the feature flag is enabled or
// enabled for test users and tthe feature
// flag does not belong to any cohort
function enabledForUser(flag, user) {
  return (
    !flag.cohort && (flag.status === "active" || enabledForTest(flag, user))
  );
}

export function featureFlagEnabled({ name, user, featureFlags }) {
  const currentFlag = featureFlags.find(flag => flag.name === name);

  if (!currentFlag) return false;

  return (
    enabledForCohort(currentFlag, user) || enabledForUser(currentFlag, user)
  );
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/featureFlag.js